import { FormInput } from "components/ui/forms/form-input";
import { PropertyFieldSection } from "../../property-field-section";
import { FormCurrency } from "components/ui/forms/form-currency";
import { FormBoolean } from "components/ui/forms/form-boolean";
import { getKeyOfPropertyUnit } from "../../../utils/get-key-of-property-unit";
import { PropertySectionKind } from "../../../types/property-section.view-model";

type PropertySecurityUnitTemplateProps = {
  unitNumber: number;
  securityNumber: number;
};

export function PropertySecurityUnitTemplate({
  unitNumber,
  securityNumber,
}: PropertySecurityUnitTemplateProps) {
  return (
    <PropertyFieldSection title={`Unit ${unitNumber}`} kind={PropertySectionKind.Unit}>
      <FormInput
        type="text"
        name={getKeyOfPropertyUnit("unit_number", securityNumber, unitNumber)}
        label={`Unit Name`}
      />
      <FormCurrency
        name={getKeyOfPropertyUnit("unit_value", securityNumber, unitNumber)}
        label="Unit Value"
      />
      <FormInput
        type="number"
        name={getKeyOfPropertyUnit("unit_square_feet", securityNumber, unitNumber)}
        label="Unit Square Feet"
      />
      <FormBoolean
        name={getKeyOfPropertyUnit("unit_sold", securityNumber, unitNumber)}
        label="Unit Sold"
      />
    </PropertyFieldSection>
  );
}
